import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// 重写路由的push方法 解决路由跳转到当前页面的时候会报错
const originalPush = VueRouter.prototype.push;
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};
/**
 * meta : {
 *    no_auth:true,   不需要权限验证
 *    hide_menu:true, 是否在菜单中隐藏
 * }
 */

const router = new VueRouter({
    mode: 'hash',
    // base: process.env.BASE_URL,
    routes: [
        {
            path: '/no-auth/:lang/:meeting_id',
            name: 'NoAuth',
            meta: {
                title: '无权限页面',
                no_auth: true
            },
            component: () => import(/* webpackChunkName: "NoAuth" */ '../views/no-auth.vue')
        }
    ]
});

export default router;
